var mangso = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];

function dochangchuc(so, daydu) {
    var chuoi = '';
    chuc = Math.floor(so / 10);
    donvi = so % 10;
    if (chuc > 1) {
        chuoi = ' ' + mangso[chuc] + ' mươi';
        if (donvi == 1) {
            chuoi += ' mốt';
        }
    } else if (chuc == 1) {
        chuoi = ' mười';
        if (donvi == 1) {
            chuoi += ' một';
        }
    } else if (daydu && donvi > 0) {
        chuoi = ' lẻ';
    }
    if (donvi == 5 && chuc >= 1) {
        chuoi += ' lăm';
    } else if (donvi > 1 || (donvi == 1 && chuc == 0)) {
        chuoi += ' ' + mangso[donvi];
    }
    return chuoi;
}

function docblock(so, daydu) {
    var chuoi = '';
    tram = Math.floor(so / 100);
    so = so % 100;
    if (daydu || tram > 0) {
        chuoi = ' ' + mangso[tram] + ' trăm';
        chuoi += dochangchuc(so, true);
    } else {
        chuoi = dochangchuc(so, false);
    }
    return chuoi;
}

function dochangtrieu(so, daydu) {
    var chuoi = '';
    trieu = Math.floor(so / 1000000);
    so = so % 1000000;
    if (trieu > 0) {
        chuoi = docblock(trieu, daydu) + ' triệu';
        daydu = true;
    }
    nghin = Math.floor(so / 1000);
    so = so % 1000;
    if (nghin > 0) {
        chuoi += docblock(nghin, daydu) + ' nghìn';
        daydu = true;
    }
    if (so > 0) {
        chuoi += docblock(so, daydu);
    }
    return chuoi;
}

function docso(so) {
    if (so == 0) return mangso[0];
    var chuoi = '',
        hauto = '';
    do {
        ty = so % 1000000000;
        so = Math.floor(so / 1000000000);
        if (so > 0) {
            chuoi = dochangtrieu(ty, true) + hauto + chuoi;
        } else {
            chuoi = dochangtrieu(ty, false) + hauto + chuoi;
        }
        hauto = ' tỷ';
    } while (so > 0);
    return chuoi;
}

function validatePhone(phone) {
    var phoneRe = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return phoneRe.test(phone);
}

function reformatPhone(phone) {
    var _arrs = phone.match(/\d/g);
    return _arrs.join('');
}

function parseDateValue(rawDate) {
    var dateArray = rawDate.split('/');
    var parsedDate = dateArray[2] + dateArray[1] + dateArray[0];
    return parsedDate;
}

Number.prototype.format = function (n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};

Number.prototype.formatDot = function (n, x) {
    //let val = (value/1).toFixed(fixed).replace('.', '')
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&.');
    //return value;
};

Date.prototype.addDays = function (days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
};

function sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
        if ((new Date().getTime() - start) > milliseconds) {
            break;
        }
    }
}

(function ($) {
    /* jshint expr: true */
    $.fn.extend({
        donetyping: function (callback, timeout) {
            timeout = timeout || 300;
            var timeoutReference,
                doneTyping = function (el) {
                    if (!timeoutReference) return;
                    timeoutReference = null;
                    callback.call(el);
                };
            return this.each(function (i, el) {
                var $el = $(el);
                $el.is(':input') && $el.on('keyup keypress', function (e) {
                    if (e.type == 'keyup' && e.keyCode != 8) return;

                    if (timeoutReference) clearTimeout(timeoutReference);
                    timeoutReference = setTimeout(function () {
                        doneTyping(el);
                    }, timeout);
                });

                $el.is(':input') && $el.on('change', function (e) {
                    if (timeoutReference) clearTimeout(timeoutReference);
                    timeoutReference = setTimeout(function () {
                        doneTyping(el);
                    }, timeout);
                });

                $el.is('textarea') && $el.on('keyup keypress', function (e) {
                    if (e.type == 'keyup' && e.keyCode != 8) return;

                    if (timeoutReference) clearTimeout(timeoutReference);
                    timeoutReference = setTimeout(function () {
                        doneTyping(el);
                    }, timeout);
                });


                $el.on('paste', function (e) {
                    if (timeoutReference) clearTimeout(timeoutReference);
                    timeoutReference = setTimeout(function () {
                        doneTyping(el);
                    }, timeout);
                });
            });
        },
        goTo: function () {
            $('html, body').animate({
                scrollTop: $(this).offset().top + 'px'
            }, 'fast');
            return this; // for chaining...
        },
        focusTextToEnd: function () {
            this.focus();
            var $thisVal = this.val();
            this.val('').val($thisVal);
            return this;
        }
    });
})(jQuery);


// SELECT 2
if($.fn.select2){
	(function($) {

		var Defaults = $.fn.select2.amd.require('select2/defaults');

		$.extend(Defaults.defaults, {
			searchInputPlaceholder: 'Nhập từ khóa để tìm kiếm'
		});

		var SearchDropdown = $.fn.select2.amd.require('select2/dropdown/search');

		var _renderSearchDropdown = SearchDropdown.prototype.render;

		SearchDropdown.prototype.render = function(decorated) {
			// invoke parent method
			var $rendered = _renderSearchDropdown.apply(this, Array.prototype.slice.apply(arguments));
			this.$search.attr('placeholder', this.options.get('searchInputPlaceholder'));
			return $rendered;
		};

	})(jQuery);
}
// END SELECT2

var common_app = common_app || {};
common_app = {
    document: $(document),
    body: $(document.body),
    observer: null,
    current_estate_id: 0,
    current_province_id: 0,
    current_district_id: 0,
    current_ward_id: 0,
    current_new_ward_id: 0,
    current_street_id: 0,
    current_project_id: 0,
    is_requesting: false,
	post_favorists: [],
	html_action: 'append',
    static_api_upload_url: static_upload_url || 'https://static123.com/api/upload',
    _ajax_project_search: {
        placeholder: 'Chọn dự án',
        ajax: {
            delay: 250,
            url: base_url + '/api/get/project/search',
            data: function (params) {
                var query = {
                    s: params.term,
                    'estate_id': $('.js_loai_bat_dong_san').val() || 5
                };

                return query;
            },
            processResults: function (response) {
                var projects = response.projects || [];
                var _results = $.map(projects, function (_project) {
                    return {
                        'id': _project.id,
                        'text': _project.title,
                        'province_id': _project.province ? _project.province.id : 0,
                        'district_id': _project.district ? _project.district.id : 0
                    };
                });
                return {
                    results: _results
                };
            },
            minimumInputLength: 2
        },
        language: {
            'noResults': function () {
                return 'Nhập tên dự án để tìm...';
            }
        },
    },
    getProjects: function () {
        var self = this;
        if (!self.current_district_id) return;

        $.ajax({
            type: 'POST',
            url: base_api_url + '/get/projects',
            data: {
                'province': self.current_province_id,
                'district': self.current_district_id,
                'estate_id': $('.js_loai_bat_dong_san').val() || 0
            },
            dataType: 'json',
            success: function (response) {
                if (response.code == 200) {
                    $('.js-select-project').empty();
                    var results = $.map(response.projects, function (_project) {
                        return {
                            'id': _project.id,
                            'text': _project.title
                        };
                    });

                    results.unshift({
                        id: '0',
                        text: response.projects && response.projects.length ? 'Chọn dự án' : 'Không có dự án nào'
                    });

                    $('.js-select-project').select2({
                        'data': results,
                        placeholder: 'Chọn dự án'
                    });

                    if (self.current_project_id) {
                        $('.js-select-project').val(self.current_project_id).trigger('change');
                    }
                }
            },
            error: function (response) {
                self.is_requesting = false;
            }
        });
    },
    getDistricts: function (province_id, current_district_id) {
        var self = this;
        self.current_district_id = current_district_id || 0;
        if (province_id == 0 || province_id == '') return;

        if (self.is_requesting) return;
        self.is_requesting = true;

        $.ajax({
            type: 'POST',
            url: base_api_url + '/get/districts',
            //url: 'https://api.bds123.vn/districts',
            data: {
                'province': province_id
            },
            dataType: 'json',
            success: function (response) {
                self.is_requesting = false;
                if (response.code == 200) {

                    $('.js-select-phuongxa').empty();
                    $('.js-select-phuongxa').select2({
                        'data': [{
                            id: '0',
                            text: 'Chọn phường xã'
                        }],
                    });
                    $('.js-select-duong').empty();
                    $('.js-select-duong').select2({
                        'data': [{
                            id: '0',
                            text: 'Chọn đường phố'
                        }],
                    });

                    $('.js-select-quanhuyen').empty();
                    var results = $.map(response.districts, function (_district) {
                        return {
                            'id': _district.id,
                            'text': _district.name
                        };
                    });
                    results.unshift({
                        id: '0',
                        text: 'Chọn quận huyện'
                    });

                    $('.js-select-quanhuyen').select2({
                        'data': results,
                        placeholder: 'Chọn quận huyện'
                    });

                    if (self.current_district_id) {
                        $('.js-select-quanhuyen').val(self.current_district_id).trigger('change');
                    }
                }
            },
            error: function (response) {
                self.is_requesting = false;
            }
        });
    },
    getWards: function (district_id, current_ward_id) {
        var self = this;
        self.current_ward_id = current_ward_id || 0;
        if (district_id == 0 || district_id == '') return;
        if ($('.js-select-phuongxa').length <= 0) return;

        $.ajax({
            type: 'POST',
            url: base_api_url + '/get/wards',
            //url: 'https://api.bds123.vn/wards',
            data: {
                'district': district_id
            },
            dataType: 'json',
            success: function (response) {
                self.is_requesting = false;
                if (response.code == 200) {
                    $('.js-select-phuongxa').empty();
                    var results = $.map(response.wards, function (_ward) {
                        return {
                            'id': _ward.id,
                            'text': _ward.name
                        };
                    });

                    results.unshift({
                        id: '0',
                        text: 'Chọn phường xã'
                    });

                    $('.js-select-phuongxa').select2({
                        'data': results,
                        placeholder: 'Chọn phường xã'
                    });

                    if (self.current_ward_id) {
                        $('.js-select-phuongxa').val(self.current_ward_id).trigger('change');
                    }
                }
            },
            error: function (response) {
                self.is_requesting = false;
            }
        });
    },
    getNewWardsByProvince: function (province_id, current_new_ward_id) {
        var self = this;
        var $newWard = $('.js-select-phuongxa-new');
        if ($newWard.length <= 0) return;

        self.current_new_ward_id = current_new_ward_id || 0;
        $newWard.empty().select2({
            'data': [{
                id: '0',
                text: $newWard.attr('data-choose-text') || 'Chọn phường xã mới'
            }],
            placeholder: $newWard.attr('data-choose-text') || 'Chọn phường xã mới'
        });

        $('.js-select-duong').empty().select2({
            'data': [{
                id: '0',
                text: 'Chọn đường phố'
            }],
            placeholder: 'Chọn đường phố'
        });

        if (province_id == 0 || province_id == '') return;

        $.ajax({
            type: 'POST',
            url: base_api_url + '/get/new-wards',
            data: {
                'province_id': province_id
            },
            dataType: 'json',
            success: function (response) {
                if (response.code == 200) {
                    var results = $.map(response.new_wards || [], function (_ward) {
                        return {
                            'id': _ward.id,
                            'text': _ward.name,
                            'district_id': parseInt(_ward.district_id || 0, 10),
                            'legacy_district_ids': $.map(_ward.legacy_district_ids || [], function (districtId) {
                                districtId = parseInt(districtId || 0, 10);
                                return districtId > 0 ? districtId : null;
                            })
                        };
                    });

                    results.unshift({
                        id: '0',
                        text: $newWard.attr('data-choose-text') || 'Chọn phường xã mới'
                    });

                    $newWard.empty().select2({
                        'data': results,
                        placeholder: $newWard.attr('data-choose-text') || 'Chọn phường xã mới'
                    });

                    if (self.current_new_ward_id) {
                        $newWard.val(self.current_new_ward_id).trigger('change');
                    } else {
                        $newWard.val('0').trigger('change.select2');
                    }
                }
            }
        });
    },
    getStreets: function (district, current_street_id) {
        var self = this;
        var $selectedNewWard = $('.js-select-phuongxa-new');
        var selectedWardData = $selectedNewWard.length ? $selectedNewWard.select2('data') : [];
        var selectedWard = selectedWardData && selectedWardData.length ? selectedWardData[0] : null;
        var districtIds = $.isArray(district && district.legacy_district_ids) && district.legacy_district_ids.length
            ? district.legacy_district_ids
            : [typeof district === 'object' ? district.district_id : district];

        if (selectedWard && String(selectedWard.district_id) === String(districtIds[0]) && $.isArray(selectedWard.legacy_district_ids) && selectedWard.legacy_district_ids.length) {
            districtIds = selectedWard.legacy_district_ids;
        }

        districtIds = $.map(districtIds, function (districtId) {
            districtId = parseInt(districtId || 0, 10);
            return districtId > 0 ? districtId : null;
        });
        if (!districtIds.length) return;

        self.current_street_id = current_street_id || 0;
        if ($('.js-select-duong').length <= 0) return;
        self.street_request_id = (self.street_request_id || 0) + 1;
        var streetRequestId = self.street_request_id;
        var selectedStreetId = self.current_street_id;

        $.ajax({
            type: 'POST',
            url: base_api_url + '/get/streets',
            data: {
                'district_ids': districtIds
            },
            dataType: 'json',
            success: function (response) {
                if (streetRequestId !== self.street_request_id) return;

                if (response.code == 200) {
                    $('.js-select-duong').empty();
                    var results = $.map(response.streets, function (_street) {
                        return {
                            'id': _street.id,
                            'text': _street.name
                        };
                    });

                    results.unshift({
                        id: '0',
                        text: 'Chọn đường phố'
                    });
                    $('.js-select-duong').select2({
                        'data': results,
                        placeholder: 'Chọn đường phố'
                    });

                    if (selectedStreetId) {
                        $('.js-select-duong').val(selectedStreetId).trigger('change');
                    }
                }
            },
            error: function (response) {
                if (streetRequestId !== self.street_request_id) return;
                self.is_requesting = false;
            }
        });
    },
    layoutCommon: function () {
		var self = this;
        $('#back_to_top').on('click', function () {
            $('html, body').animate({
                scrollTop: 0
            }, 'slow');
            return false;
        });

		$(self.body).on('click', '.js-user-logout', function(e){
			e.preventDefault();

			var _self = $(this);
			var logout_url = _self.attr('href');
			localStorage.removeItem('authenticated');
			localStorage.removeItem('verified');
			localStorage.removeItem('access_token');
			localStorage.removeItem('bds123.user_data');
			window.location.href = logout_url;
		});

		if (typeof ClipboardJS !== 'undefined') {
            // if ($('.js-btn-copy').length) {
			// 	var copylink_clipboard = new ClipboardJS('.js-btn-copy');
			// 	copylink_clipboard.on('success', function (e) {
			// 		$(e.trigger).addClass('active btn-primary').removeClass('btn-secondary');
			// 		setTimeout(function () {
			// 			$(e.trigger).removeClass('active btn-primary').addClass('btn-secondary');
			// 		}, 1000);

			// 	});
            // }
            if($('.js-btn-copy').length){
				var copylink_clipboard = new ClipboardJS('.js-btn-copy');
				copylink_clipboard.on('success', function (e) {
					$(e.trigger).addClass('copied');
					setTimeout(function () {
						$(e.trigger).removeClass('copied');
					}, 1000);

				});
			}
        }

        // button close và reload lại trang

        $('body').on('click', '.js-close-and-reload', function (event) {
            event.preventDefault();

            location.reload();
        });

		$('.js-scroll-top').on('click', function (e) {
			$('html,body').animate({ scrollTop: 0 }, 0);
		});
    },
    isFacebookApp: function () {
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        return (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1);
    },
    lazyLoadImage: function () {
        if (typeof lozad === 'function') {
            this.observer = lozad('.lazy', {
                rootMargin: '300px 0px', // syntax similar to that of CSS Margin
                threshold: 0.1,
                loaded: function (element) {
                    element.classList.add('lazy_done');
                    element.classList.remove('lazy');
                }
            });
            this.observer.observe();
        }
    },
    escapePopup: function () {
        this.document.keyup(function (e) {
            if (e.keyCode == 27) { // escape key maps to keycode `27`
                $('.js-close-swiper-property-photos').trigger('click');
                $('.js-close-swiper-project-gallery').trigger('click');
            }
        });
    },
    detectLocation: function () {
        var self = this;
        if (navigator.geolocation && self.body.hasClass('home') && !self.body.hasClass('page-province')) {
            navigator.geolocation.getCurrentPosition(function (position) {
                window.show_loading = false;
                $.ajax({
                    url: base_url + '/utility/find-location',
                    data: {
                        'map_lat': position.coords.latitude,
                        'map_long': position.coords.longitude
                    },
                    type: 'POST',
                    dataType: 'json',
                });
            });
        }
    },
    moveToTrash: function () {
        $('.js-item-row').on('click', '.js-move-to-trash', function (event) {
            event.preventDefault();

            var object_id = $(this).attr('data-id');
            var object_type = $(this).attr('data-type');
            var object_action = $(this).attr('data-end-action') ? $(this).attr('data-end-action') : '';

            if (!object_id || !object_type) return;
            $.ajax({
                url: base_api_url + '/utility/confirm_trash',
                data: {
                    'object_id': object_id,
                    'object_type': object_type,
                    'object_action': object_action
                },
                type: 'POST',
                dataType: 'json'
            });
        });

        $('.js-media-info').on('click', '.js-move-to-trash', function (event) {
            event.preventDefault();

            var object_id = $(this).attr('data-id');
            var object_type = $(this).attr('data-type');
            var object_action = $(this).attr('data-action') ? $(this).attr('data-action') : '';

            if (!object_id || !object_type) return;
            $.ajax({
                url: base_api_url + '/utility/confirm_trash',
                data: {
                    'object_id': object_id,
                    'object_type': object_type,
                    'object_action': object_action
                },
                type: 'POST',
                dataType: 'json'
            });
        });

        $('.js-btn-confirm-move-to-trash').on('click', function (event) {
            event.preventDefault();

            $('#modal_confirm_trash').modal('hide');

            var object_id = $(this).attr('data-objet-id');
            var object_type = $(this).attr('data-type');
            var object_action = $(this).attr('data-action');
            $.ajax({
                url: base_api_url + '/utility/movetotrash',
                data: {
                    'object_id': object_id,
                    'object_type': object_type,
                    'object_action': object_action
                },
                type: 'POST',
                dataType: 'json'
            });
        });
    },
    media: {
        is_requesting: false,
        can_get_more_medias: true,
        showMediaPopup: function () {
            $('.js-btn-show-image-popup').on('click', function (event) {
                event.preventDefault();
                var type_target = $(this).attr('data-type-target') ? $(this).attr('data-type-target') : 'post';
                var support_choice = $(this).attr('data-choice') ? $(this).attr('data-choice') : 'multiple';
                var insert_to = $(this).attr('data-insert') ? $(this).attr('data-insert') : 'content';
                var input_image_name = $(this).attr('data-input-field-name') ? $(this).attr('data-input-field-name') : 'image_linked_slider';
                var allow_featured_field = $(this).attr('data-allow-featured') ? $(this).attr('data-allow-featured') : 0;
                $.ajax({
                    url: base_api_url + '/utility/media',
                    data: {
                        'data_type': type_target,
                        'support_choice': support_choice,
                        'insert_to': insert_to,
                        'input_name': input_image_name,
                        'allow_featured_field': allow_featured_field
                    },
                    type: 'POST',
                    dataType: 'json',
                });
            });
        },
        // PROGRESS FOR UPLOAD
        add_file: function (id, file) {
            /* preparing image for preview */
            if (typeof FileReader !== 'undefined') {

                var reader = new FileReader();
                reader.onload = function (e) {
                    var file_ext = file.name.split('.').pop().toLowerCase();

                    var image_preview = e.target.result;
                    var thumbnail_class = 'image';
                    if (file_ext == 'png' || file_ext == 'jpg' || file_ext == 'jpeg' || file_ext == 'gif') {
                        image_preview = e.target.result;
                    } else {
                        thumbnail_class = 'file';
                        image_preview = base_url + '/images/exts/icon-' + file_ext + '.png';
                    }

                    var template = '' +
                        '<div id="media_item_' + id + '" class="media_item js-media-item ' + thumbnail_class + '" data-file-type="' + thumbnail_class + '" data-extension="' + file_ext + '" data-id="" data-path-url="" data-url="" data-title="" data-description="" data-alt-title="" data-file-name="' + file.name + '" data-width="" data-height="" data-size="" data-created-at="">' +
                        '<div class="media_item_preview">' +
                        '<div class="media_item_thumbail">' +
                        '<img src="' + image_preview + '"></div>' +
                        '<span>' + file.name + '</span>' +
                        '</div>' +
                        '<button type="button" class="check"><span class="media-modal-icon"></span></button>' +
                        '<div class="progress">' +
                        '<div class="progress-bar progress-bar-success js-progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" style="width: 40%">' +
                        '<span>40%</span>' +
                        '</div>' +
                        '</div>' +
                        '</div>';
                    $('.js-media-list').prepend(template);
                };

                reader.readAsDataURL(file);
            }
        },
        update_file_status: function (id, status, message) {
            $('#media_item_' + id).addClass(status);
        },
        update_file_progress: function (id, percent) {
            $('#media_item_' + id).find('.js-progress-bar').width(percent);
            $('#media_item_' + id).find('.js-progress-bar span').html(percent);
        },
        bgLoadMoreImages: function (offset, limit, action) {
            var self = this;
            offset = offset || 0;
            limit = limit || 20;
            action = action || 'append';
            // dang request thi ko lam gi het
            if (self.is_requesting) return;
            self.is_requesting = true;

            var filetype = $('.js-select-filetype').val();
            var time = $('.js-select-time').val();
            var searching = $('.js-input-filter-media').val();
            var post_id = $('#post_id').val();

            $.ajax({
                url: static_media_url || 'https://static123.com/api/media',
                data: {
                    'start_offset': offset,
                    'limit': limit,
                    'filetype': filetype,
                    'time': time,
                    'action': action,
                    'search': searching,
                    'post_id': post_id,
                    'source': 'bds123.vn',
                    'user_id': current_user_id || 1
                },
                type: 'POST',
                dataType: 'json',
                success: function (response) {
                    self.is_requesting = false;
                    self.initEventMediaModule();
                },
                error: function (response) {
                    self.is_requesting = false;
                }
            });
        },
        reorderImage: function () {
            if ($('.js-upload-progress-wrapper').find('.media').length) {
                $('.js-upload-progress-wrapper').sortable({
                    tolerance: 'pointer'
                });
            }
            if ($('.js-upload-linked-wrapper').find('.media').length) {
                $('.js-upload-linked-wrapper').sortable({
                    tolerance: 'pointer'
                });
            }
        },
        popupMediaModule: function () {
            var self = this;
            self.bgLoadMoreImages();
            //initEventMediaModule();

            $('.js-media-list').on('scroll', function () {
                var offset_begin_tracked = 160;
                if ($(this).scrollTop() + $(this).innerHeight() + offset_begin_tracked >= $(this)[0].scrollHeight) {

                    // nếu còn có thể get media thì mới cho get ko cứ phải ajax hoài
                    if (self.can_get_more_medias) {
                        self.bgLoadMoreImages($('.js-media-list .js-media-item').length, 20);
						common_app.html_action = 'append';
                    }
                }
            });

            $('.js-select-filetype, .js-select-time').on('change', function () {
                // load lại từ đầu
                self.bgLoadMoreImages(0, 30, 'replace');
				common_app.html_action = 'replace';
            });

            $('.js-button-filter-media').on('click', function () {
                self.bgLoadMoreImages(0, 30, 'replace');
				common_app.html_action = 'replace';
            });

            $('.js-input-filter-media').donetyping(function () {
                self.bgLoadMoreImages(0, 30, 'replace');
				common_app.html_action = 'replace';
            });

            // Xử lí insert image
            $('.js-button-insert-media').on('click', function (event) {
                event.preventDefault();

                var support_choice = $('.js-media-list').attr('data-choice') ? $('.js-media-list').attr('data-choice') : 'single';
                var insert_to = $(this).attr('data-insert-to');
                var input_name = $(this).attr('data-input-field-name');
                var allow_featured_field = $(this).attr('data-allow-featured-field');
                var require_data_type = $(this).attr('data-type');

                if (support_choice == 'single') {
                    var dom_insert_to = '.' + insert_to;
                    if (insert_to.charAt(0) == '.' || insert_to.charAt(0) == '#') {
                        dom_insert_to = insert_to;
                    }
                    var parent_el = $(dom_insert_to).parent();
                    var input_value_el = parent_el.find('.js-input-value');
                    //$('.js-media-item.selected').each(function(index, el){
                    $('.js-selected-image-wrap .js-image-selected').each(function (index, el) {
                        var media_item = $(el);
                        var image_url = media_item.attr('data-url');
                        var image_path = media_item.attr('data-path-url');
                        var file_type = media_item.attr('data-file-type');
                        var extension = media_item.attr('data-extension');
                        var filename = media_item.attr('data-file-name');
                        if (file_type != require_data_type) return;

                        var one_image_html = '' +
                            '<div class="one_featured_image_src js-one-image-preview" style="background:url(' + image_url + ') no-repeat center center; background-size:cover"></div>' +
                            '<a class="remove-image js-remove-one-image"><span><i class="fa fa-trash" aria-hidden="true"></i> Xóa hình này</span></a>';
                        if (file_type != 'image') {
                            var icon_preview = base_url + '/images/exts/icon-' + extension + '.png';
                            one_image_html = '' +
                                '<div class="one_featured_image_src js-one-image-preview">' +
                                '<img src="' + icon_preview + '"/> <span>' + filename + '</span>' +
                                '</div>' +
                                '<a class="remove-image js-remove-one-image"><span><i class="fa fa-trash" aria-hidden="true"></i> Xóa file này</span></a>';

                            if (file_type == 'video') {
                                one_image_html = '' +
                                    '<div class="one_featured_video_src js-one-video-preview">' +
                                    '<video width="320" height="240" controls>' +
                                    '<source src="' + image_url + '" type="video/mp4">' +
                                    'Your browser does not support the video tag.' +
                                    '</video>' +
                                    '</div>' +
                                    '<a class="remove-image js-remove-one-image"><span><i class="fa fa-trash" aria-hidden="true"></i> Xóa file này</span></a>';

                            }
                        }
                        $(dom_insert_to).html(one_image_html);

                        parent_el.addClass('upload_done');
                        input_value_el.val(image_path);

                        // bind event
                        $(dom_insert_to).on('click', '.js-remove-one-image', function (event) {
                            event.preventDefault();

                            $(dom_insert_to).html('');
                            parent_el.removeClass('upload_done');
                            input_value_el.val('');
                        });
                    });
                }

                if (support_choice == 'multiple') {
                    // trường hợp editor

                    if (insert_to == 'js-editor-content') {
                        var tinymce_id = $('.' + insert_to).attr('data-insert-id') || $('.' + insert_to).attr('id');
                        var html_insert = '';
                        //$('.js-media-item.selected').each(function(index, el){
                        $('.js-selected-image-wrap .js-image-selected').each(function (index, el) {

                            var media_item = $(el);
                            var image_url = media_item.attr('data-url');
                            var image_title = media_item.attr('data-title');
                            var image_description = media_item.attr('data-description');
                            var image_alt = media_item.attr('data-alt-title');
                            var image_id = media_item.attr('data-id');
                            var file_type = media_item.attr('data-file-type');

                            if (file_type != require_data_type) return;

                            var image_tag = '<figure><img src="' + image_url + '" alt="' + image_alt + '" title="' + image_title + '">';
                            if (image_description) {
                                image_tag += '<figcaption>' + image_description + '</figcaption>';
                            }
                            image_tag += '</figure>';

                            html_insert += image_tag;
                        });

                        tinymce.get(tinymce_id).execCommand('mceInsertContent', false, html_insert + '\n');
                    } else {
                        //$('.js-media-item.selected').each(function(index, el){
                        $('.js-selected-image-wrap .js-image-selected').each(function (index, el) {
                            var media_item = $(el);
                            var image_url = media_item.attr('data-url');
                            var image_path = media_item.attr('data-path-url');
                            var image_id = media_item.attr('data-id');
                            var image_title = media_item.attr('data-title');
                            var image_description = media_item.attr('data-description');
                            var image_alt_title = media_item.attr('data-alt-title');
                            var image_width = media_item.attr('data-width');
                            var image_height = media_item.attr('data-height');
                            var image_size = media_item.attr('data-size');
                            var file_type = media_item.attr('data-file-type');

                            if (file_type != require_data_type) return;

                            var item_image_html = '' +
                                '<div class="media" id="media_' + image_id + '">' +
                                '<div class="media-left">' +
                                '<div class="upload_thumb" style="background:url(' + image_url + ') center no-repeat; background-size: cover;"></div>' +
                                '</div>' +
                                '<div class="media-body">' +
                                '<span class="delete_image js-delete-image"><i class="fa fa-trash-o" aria-hidden="true"></i> Xóa hình này</span>' +
                                '<input type="hidden" name="' + input_name + '[' + image_id + ']" value="' + image_path + '"/>' +
                                '<input type="hidden" name="image_titles[' + image_id + ']" value="' + image_title + '"/>' +
                                '<input type="hidden" name="image_descriptions[' + image_id + ']" value="' + image_description + '"/>' +
                                '<input type="hidden" name="image_alt_titles[' + image_id + ']" value="' + image_alt_title + '"/>' +
                                '<input type="hidden" name="image_widths[' + image_id + ']" value="' + image_width + '"/>' +
                                '<input type="hidden" name="image_heights[' + image_id + ']" value="' + image_height + '"/>' +
                                '<input type="hidden" name="image_sizes[' + image_id + ']" value="' + image_size + '"/>';
                            if (allow_featured_field) {
                                item_image_html += '<div class="featured_image">' +
                                    '<input id="label_' + image_id + '" type="radio" name="featured_image" value="' + image_path + '" /> <label for="label_' + image_id + '">Hình đại diện</label>' +
                                    '</div>';
                            }

                            item_image_html += '</div>' +
                                '</div>';

                            var found = false;
                            $('.' + insert_to + ' .media').each(function (index, el) {
                                if ($(el).attr('id') == 'media_' + image_id) {
                                    found = true;
                                    return false;
                                }
                            });
                            if (!found) {
                                $('.' + insert_to).append(item_image_html);
                            }

                            // bind event cho xóa item
                            self.removeChooseImage();
                            self.reorderImage();
                        });
                    }
                }

                $('.js-model-media-popup').modal('hide');
            });

            var current_user_str = localStorage.getItem('bds123.user_data');
            var current_user = current_user_str ? JSON.parse(current_user_str) : false;
            var page_from = window.location.href.indexOf('sua-tin') !== -1 ? 'dangtin' : '';
            var ext_filter = ['jpg', 'png', 'gif', 'jpeg', 'JPG', 'JPEG', 'PNG', 'doc', 'docx', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx'];
            var allowed_types = 'doc|docx|pdf|xls|xlsx|ppt|pptx|image\/*';
            if (page_from == 'dangtin') {
                ext_filter = ['jpg', 'png', 'jpeg', 'JPG', 'JPEG', 'PNG', 'mp4', 'MP4', 'mov', 'MOV'];
                allowed_types = 'image\/*';
            }

            $('.js-drag-and-drop-zone').dmUploader({
                //url: base_url + '/image/uploadimage',
                url: common_app.static_api_upload_url,
                dataType: 'json',
                // allowedTypes: allowed_types,
                extFilter: ext_filter,
                maxFileSize: 100000000,
                extraData: {
                    'source': 'bds123.vn',
                    'source_url': window.location.href,
                    'user_id': current_user ? current_user.id : 1,
                    'from': window.location.href.indexOf('sua-tin') > -1 ? 'dangtin' : '',
                    'estate_type': $('.js-form-submit-data').find('input[name="type"]').val()
                },
                onInit: function () {

                },
                onBeforeUpload: function (id) {
                    self.update_file_status(id, 'uploading', 'Uploading...');
                },
                onNewFile: function (id, file) {
                    self.add_file(id, file);
                    $('.js-nav-tabs a[href="#library_media"]').tab('show');
                },
                onComplete: function () {
                    // khởi tạo lấy mấy event click cho các item mới được add vô
                    self.initEventMediaModule();
                },
                onUploadProgress: function (id, percent) {
                    var percentStr = percent + '%';
                    self.update_file_progress(id, percentStr);
                },
                onUploadSuccess: function (id, data) {
                    $('#media_item_' + id).addClass('upload_done');
                    self.update_file_status(id, 'selected', 'Upload Complete');
                    self.update_file_progress(id, '100%');
                    /*jshint -W069 */
                    args = []; //new Array();
                    if (data.file_type == 'file' || data.file_type == 'other') {
                        args['url'] = data.file_url;
                    } else if (data.file_type == 'video') {
                        args['url'] = data.video_url;
                    } else {
                        args['url'] = data.full_image_900_url;
                    }
                    args['path_url'] = data.image_path;
                    args['filename'] = data.filename;
                    args['created_at'] = data.created_at;
                    args['size'] = data.size;
                    args['width'] = data.width;
                    args['height'] = data.height;
                    args['description'] = '';
                    args['title'] = '';
                    args['alt_title'] = '';
                    args['id'] = data.image_id;
                    args['filetype'] = data.file_type;
                    args['extension'] = data.extension;

                    // fill lại info cho cái selected ở media info left
                    self.fillMediaInfo(args);
                    self.addSelectedImageToPreview(args);

                    // set lại value mới sau khi upload hình thành công
                    if (data.file_type == 'image') {
                        $('#media_item_' + id).find('img').attr('src', data.full_image_900_url);
                    } else {
                        var image_preview = base_url + '/images/exts/icon-' + data.extension + '.png';
                        $('#media_item_' + id).find('img').attr('src', image_preview);
                    }
                    $('#media_item_' + id).attr('data-id', data.image_id)
                        .attr('data-url', args['url'])
                        .attr('data-path-url', args['path_url'])
                        .attr('data-width', data.width)
                        .attr('data-height', data.height)
                        .attr('data-size', data.size)
                        .attr('data-created-at', data.created_at)
                        .attr('id', 'media_item_' + data.image_id)
                        .attr('data-file-type', data.file_type)
                        .attr('data-extension', data.extension);
                },
                onUploadError: function (id, message) {
                    console.log('Failed to Upload file #' + id + ': ' + message);
                    self.update_file_status(id, 'error', message);
                },
                onFileTypeError: function (file) {
                    console.log('File \'' + file.name + '\' cannot be added: must be an image');
                },
                onFileSizeError: function (file) {
                    alert('File \'' + file.name + '\' không thể upload: tối đa 50mb/file');
                },
                onFileExtError: function (file) {
                    alert('File \'' + file.name + '\' không đúng định dạng file');
                },
                onFallbackMode: function (message) {
                    alert('Browser not supported(do something else here!): ' + message);
                }
            });
        },
        fillMediaInfo: function (args) {
            /*jshint sub:true*/
            args = args || [];
            args['url'] = args['url'] || '';
            args['filename'] = args['filename'] || '';
            args['created_at'] = args['created_at'] || '';
            args['size'] = args['size'] || '';
            args['width'] = args['width'] || '';
            args['height'] = args['height'] || '';
            args['description'] = args['description'] || '';
            args['title'] = args['title'] || '';
            args['alt_title'] = args['alt_title'] || '';
            args['id'] = args['id'] || '';
            args['filetype'] = args['filetype'] || '';
            args['extension'] = args['extension'] || '';

            if (args['filetype'] == 'image') {
                $('.js-media-info .media_info_thumbnail img').attr('src', args['url']);
            } else {
                var icon_preview = base_url + '/images/exts/icon-' + args['extension'] + '.png';
                $('.js-media-info .media_info_thumbnail img').attr('src', icon_preview);
            }
            $('.js-media-info .filename').html(args['filename']);
            $('.js-media-info .uploaded').html(args['created_at']);

            if (args['size'] != 0) {
                $('.js-media-info .file-size').removeClass('hidden');
                $('.js-media-info .file-size').html(args['size']);
            } else {
                $('.js-media-info .file-size').addClass('hidden');
            }

            if (args['width'] != 0) {
                $('.js-media-info .dimensions').removeClass('hidden');
                $('.js-media-info .dimensions').html(args['width'] + ' x ' + args['height']);
            } else {
                $('.js-media-info .dimensions').addClass('hidden');
            }

            $('.js-media-info .js-image-input-url').val(args['url']);
            $('.js-media-info .js-image-input-description').val(args['description']);
            $('.js-media-info .js-image-input-title').val(args['title']);
            $('.js-media-info .js-image-input-alt-text').val(args['alt_title']);

            $('.js-media-info .js-move-to-trash').attr('data-id', args['id']);
            $('.js-input-image-id').val(args['id']);
            $('.js-media-detail').removeClass('hide');
        },
        updateImageInfo: function () {

            var image_title = $('.js-image-input-title').val();
            var image_description = $('.js-image-input-description').val();
            var image_alt = $('.js-image-input-alt-text').val();
            var image_id = $('.js-input-image-id').val();
            // chỉnh sửa lại data cho từng cái media bên trái luôn :(
            $('#media_item_' + image_id)
                .attr('data-alt-title', image_alt)
                .attr('data-description', image_description)
                .attr('data-title', image_title);

            $.ajax({
                url: base_url + '/image/update',
                data: {
                    'title': image_title,
                    'description': image_description,
                    'alt_title': image_alt,
                    'image_id': image_id
                },
                type: 'POST',
                dataType: 'json'
            });
        },
        addSelectedImageToPreview: function (args) {
            /*jshint sub:true*/
            args = args || [];
            args['url'] = args['url'] || '';
            args['path_url'] = args['path_url'] || '';
            args['filename'] = args['filename'] || '';
            args['created_at'] = args['created_at'] || '';
            args['size'] = args['size'] || '';
            args['width'] = args['width'] || '';
            args['height'] = args['height'] || '';
            args['description'] = args['description'] || '';
            args['title'] = args['title'] || '';
            args['alt_title'] = args['alt_title'] || '';
            args['id'] = args['id'] || '';
            args['filetype'] = args['filetype'] || '';
            args['extension'] = args['extension'] || '';


            var total_image = $('.js-selected-image-wrap-inner').find('.js-image-selected').length;
            /*jshint -W014 */
            var icon_preview = args['url'];
            if (args['filetype'] != 'image') {
                icon_preview = base_url + '/images/exts/icon-' + args['extension'] + '.png';
            }
            var image_selected_html =
                '<div class="image-selected js-image-selected" id="image-selected-' + (args['id']) + '" data-extension="' + args['extension'] + '" data-file-type="' + args['filetype'] + '" data-url="' + args['url'] + '" data-path-url="' + args['path_url'] + '" data-id="' + args['id'] + '" data-title="' + args['title'] + '" data-description="' + args['description'] + '" data-alt-title="' + args['alt_title'] + '" data-width="' + args['width'] + '" data-height="' + args['height'] + '" data-size="' + args['size'] + '">' +
                '<img src="' + icon_preview + '" style="width:40px; height:auto">' +
                '</div>';

            $('.js-info-inner').removeClass('hidden');
            $('.js-info-inner').find('.js-number-image').html(total_image + 1);

            $(image_selected_html).appendTo('.js-selected-image-wrap-inner');
            // thêm hình vào phần review
            $('.js-selected-image-wrap').on('click', '.js-image-selected', function (event) {
                var _self = $(this);
                var image_id = $(this).attr('data-id');

                $('.js-selected-image-wrap-inner').find('.js-image-selected').removeClass('selected');
                _self.addClass('selected');

                $('.js-media-list .js-media-item').each(function (index, el) {
                    if ($(el).attr('data-id') == image_id) {
                        $('.js-media-list .js-media-item').removeClass('detail');
                        $(el).addClass('detail');
                    }
                });
            });
        },
        removeSelectedImageInPreview: function (args) {
            /*jshint sub:true*/
            args = args || [];
            args['id'] = args['id'] || '';
            if (args['id'] == '') return;

            $('.js-selected-image-wrap-inner').find('.js-image-selected').each(function (index, el) {

                if ($(el).attr('data-id') == args['id']) {
                    $(el).remove();
                    var total_image = $('.js-selected-image-wrap-inner').find('.js-image-selected').length;
                    $('.js-info-inner').find('.js-number-image').html(total_image);
                    if (total_image == 0) {
                        $('.js-info-inner').addClass('hidden');
                    }
                }
            });
        },
        removeChooseImage: function () {
            $('.js-form-submit-data .js-remove-one-image').on('click', function (event) {
                event.preventDefault();
                var _self = $(this);
                // swal({
                //     title: 'Bạn chắc chứ?',
                //     text: 'Bạn chắc muốn xóa file này chứ',
                //     type: 'warning',
                //     showCancelButton: true,
                //     confirmButtonColor: '#3085d6',
                //     cancelButtonColor: '#d33',
                //     confirmButtonText: 'OK, Xóa nó!',
                //     cancelButtonText: 'Đóng'
                // }).then(function () {

					_self.closest('.js-one-image-wrapper').removeClass('upload_done');
					_self.closest('.js-one-image-wrapper').find('.js-one-image-preview').css({'background-image':'url(/images/default-user.svg)'});
                    _self.closest('.js-one-image-wrapper').find('.js-input-value').val('');
					_self.closest('.js-one-featured-image-wrapper').removeClass('upload_done');
					_self.closest('.js-one-featured-image-wrapper').find('.js-one-image-preview').css({'background-image':'url(/images/default-user.svg)'});
                    _self.closest('.js-one-featured-image-wrapper').find('.js-input-value').val('');
                    _self.addClass('disabled').prop('disabled', true);

                    // swal(
                    //     'Deleted!',
                    //     'Hình đã xóa thành công.',
                    //     'success'
                    // );
                // });

            });

        },
        oneMediaUpload: function () {
            if (!$.fn.dmUploader) return;
            var current_user_str = localStorage.getItem('bds123.user_data');
            var current_user = current_user_str ? JSON.parse(current_user_str) : false;

            $('.js-one-image-wrapper').each(function(index, el){
				 $(el).dmUploader({
					//url: base_url + '/image/uploadimage',
					url: common_app.static_api_upload_url,
					dataType: 'json',
					// allowedTypes: allowed_types,
					extFilter: ['jpg', 'png', 'jpeg', 'JPG', 'JPEG', 'PNG'],
					maxFileSize: 15000000,
					extraData: {
						'source': 'bds123.vn',
						'source_url': window.location.href,
						'user_id': current_user ? current_user.id : 1,
						'from': $(el).attr('data-upload-from') || 'dangtin',
						'use_cover': $(el).attr('data-type-upload') || 0
					},
					onInit: function () {

					},
					onBeforeUpload: function (id) {
					},
					onNewFile: function (id, file) {
						if (typeof FileReader !== 'undefined') {

							var reader = new FileReader();
							reader.onload = function (e) {
								var file_ext = file.name.split('.').pop().toLowerCase();

								var image_preview = e.target.result;
								var thumbnail_class = 'image';

								image_preview = e.target.result;

								$(el).find('.js-one-image-preview').css({ 'background-image': 'url(' + image_preview + ')' });
							};

							reader.readAsDataURL(file);
						}
					},
					onUploadProgress: function (id, percent) {
						var percentStr = percent + '%';
					},
					onUploadSuccess: function (id, data) {
						$(el).find('.js-one-image-preview').css({ 'background-image': 'url(' + data.full_image_url + ')' });
						$(el).find('.js-input-value').val(data.image_path);
						$(el).find('.js-remove-one-image').removeClass('disabled').prop('disabled', false);

					},
					onFileTypeError: function (file) {
						console.log('File \'' + file.name + '\' cannot be added: must be an image');
					},
					onFileSizeError: function (file) {
						alert('File \'' + file.name + '\' không thể upload: tối đa 50mb/file');
					},
					onFileExtError: function (file) {
						alert('File \'' + file.name + '\' không đúng định dạng file');
					},
					onFallbackMode: function (message) {
						alert('Browser not supported(do something else here!): ' + message);
					}
				});
			});
        },
        initEventMediaModule: function () {
            var self = this;
            $('.js-media-item').on('click', function (event, data) {
                event.preventDefault();
                event.stopPropagation();

                var _self = $(this);
                // đầu tiên phải kiểm tra xem có cho chọn nhiều hay không
                var support_choice = $('.js-media-list').attr('data-choice') ? $('.js-media-list').attr('data-choice') : 'single';
                var support_can_choice = $('.js-media-list').attr('data-can-choice') ? $('.js-media-list').attr('data-can-choice') : 'image';

                // kiểm tra xem có cho phép chòn các loại file khác hay không
                // if (support_can_choice == 'image' && !_self.hasClass('image')) {
                //     alert('Bạn chỉ được chọn hình ảnh');
                //     return;
                // }
                if (support_choice == 'single') {
                    $('.js-media-item').removeClass('selected');
                }

                // Xóa hết các detail khác đi

                $('.js-media-list .js-media-item').removeClass('detail');

                var image_url = _self.attr('data-url');
                var image_path_url = _self.attr('data-path-url');
                var image_title = _self.attr('data-title');
                var image_description = _self.attr('data-description');
                var image_alt_title = _self.attr('data-alt-title');
                var image_filename = _self.attr('data-file-name');

                var image_width = _self.attr('data-width');
                var image_height = _self.attr('data-height');
                var image_size = _self.attr('data-size');
                var image_created_at = _self.attr('data-created-at');
                var image_id = _self.attr('data-id');
                var file_type = _self.attr('data-file-type');
                var extension = _self.attr('data-extension');

                // fill data
                /*jshint sub:true*/
                var args = []; //new Array();

                args['url'] = image_url;
                args['path_url'] = image_path_url;
                args['filename'] = image_filename;
                args['created_at'] = image_created_at;
                args['size'] = image_size;
                args['width'] = image_width;
                args['height'] = image_height;
                args['description'] = image_description;
                args['title'] = image_title;
                args['alt_title'] = image_alt_title;
                args['id'] = image_id;
                args['filetype'] = file_type;
                args['extension'] = extension;

                // xem thông tin hình
                self.fillMediaInfo(args);
                _self.addClass('detail');
                $('.js-media-detail').removeClass('hide');

                // xử lí phần selected
                // nếu user dùng CMD | CTRL hoặc là call tự động thì cho phép xử lí cái chọn luôn

                if (event.metaKey || event.ctrlKey || typeof data !== 'undefined') {

                    if (!_self.hasClass('selected')) {
                        _self.addClass('selected');
                        self.addSelectedImageToPreview(args);
                    } else {
                        _self.removeClass('selected');
                        self.removeSelectedImageInPreview(args);
                    }
                } else {

                    $('.js-media-item').removeClass('selected');
                    $('.js-info-inner .js-remove-all').trigger('click');
                    if (!_self.hasClass('selected')) {
                        _self.addClass('selected');
                        self.addSelectedImageToPreview(args);
                    } else {
                        _self.removeClass('selected');
                        self.removeSelectedImageInPreview(args);
                    }
                }

                return false;
            });

            $('.js-media-list').on('click', '.js-media-item .check', function (e) {
                e.stopPropagation();

                $(this).closest('.js-media-item').trigger('click', [{
                    'from_trigger': 1
                }]);
                $(this).closest('.js-media-item').removeClass('selected');
                $(this).closest('.js-media-item').removeClass('detail');

            });

            $('.js-media-detail .js-image-input-description').donetyping(function () {
                var image_id = $('.js-input-image-id').val();
                $('#media_item_' + image_id).attr('data-description', $(this).val());
                $('#image-selected-' + image_id).attr('data-description', $(this).val());
                self.updateImageInfo();
            });

            $('.js-media-detail .js-image-input-title').donetyping(function () {
                var image_id = $('.js-input-image-id').val();
                $('#image-selected-' + image_id).attr('data-title', $(this).val());
                self.updateImageInfo();
            });

            $('.js-media-detail .js-image-input-alt-text').donetyping(function () {
                var image_id = $('.js-input-image-id').val();
                $('#image-selected-' + image_id).attr('data-alt-title', $(this).val());
                self.updateImageInfo();
            });

            // xóa tất cả selected
            $('.js-info-inner .js-remove-all').on('click', function (event) {
                $('.js-selected-image-wrap-inner').html('');

                $('.js-info-inner').find('.js-number-image').html(0);
                $('.js-media-list .js-media-item').removeClass('selected');
                $('.js-info-inner').addClass('hidden');
            });
        },
        init: function () {
            this.removeChooseImage();
            this.reorderImage();
            this.showMediaPopup();
            this.oneMediaUpload();
        }
    },
    payment: {
        order_id: 0,
        method: 'store',
        is_success: false,
        qr_checker: false,
        sepay_is_success: false,
        sepay_status_timer: false,
        payoo: function () {
            var self = this;
            $('.js-btn-cancel-qrcode').on('click', function (event) {
                event.preventDefault();

                if (self.order_id == 0) return;
                var _self = $(this);

                self.cancelPayooQRCode(_self);
            });

        },
        showPayooQRCode: function (response, form) {
            if (!response || !response.QRCodeLink) return false;

            var self = this;
            var $form = form && form.length ? form : $('.js-payment-at-store').first();
            if (!$form.length || $form.data('payoo-qrcode-order') == response.order_no) return false;

            $form.data('payoo-qrcode-order', response.order_no);
            $form.find('.js-qr-code img').attr('src', response.QRCodeLink);
            $form.find('.js-payment-step').addClass('hidden');
            $form.find('.js-payment-step.step-2').removeClass('hidden');
            $('html,body').animate({ scrollTop: 0 }, 'fast');

            self.order_id = response.order_no;
            var $timer = $form.find('.js-time-expired');
            $timer.off('update.countdown finish.countdown')
                .attr('data-time', response.validate_time)
                .countdown(response.validate_time)
                .on('update.countdown', function (event) {
                    $(this).html(event.strftime('%H:%M:%S'));

                    if (event.offset.totalSeconds % 5 == 0) {
                        self.checkPayooQRCode();
                    }
                })
                .on('finish.countdown', function () {
                    $.ajax({
                        url: base_api_url + '/payoo/cancel/qrcode',
                        data: { order_id: self.order_id, status: 'timeout' },
                        method: 'post',
                        type: 'json'
                    });
                });

            self.checkPayooQRCode();
            return true;
        },
        checkPayooQRCode: function () {
            var self = this;

            if (self.order_id == 0) return;
            if (self.is_success) return;

            $.ajax({
                url: base_api_url + '/payoo/check/qrcode',
                data: { order_id: self.order_id },
                method: 'post',
                type: 'json',
                success: function (res) {
                    if (!res.error) {
                        self.is_success = true;
                        clearTimeout(self.qr_checker);
                        return;
                    }
                    self.is_success = false;
                }
            });

            // self.qr_checker = setTimeout(function () {
            //     self.checkPayooQRCode();
            // }, 3000);
        },
        cancelPayooQRCode: function (button = null) {
            if (this.order_id == 0) return;

			var _button_text = button ? button.html() : '';
			$.ajax({
				url: base_api_url + '/payoo/cancel/qrcode',
				data: { order_id: this.order_id, status: 'cancel', action: button ? 'cancel' : 'back'},
				method: 'post',
				type: 'json',
				success: function () {
					if(button){
						button.html(_button_text);
					}
                }
            });
        },
        sepayTopUpForm: function () {
            $('.js-form-submit-data[data-action-url*="api/sepay/top-up"]').off('submit.sepay').on('submit.sepay', function (event) {
                event.preventDefault();
                event.stopImmediatePropagation();

                var $form = $(this);
                var $button = $form.find('.js-btn-hoan-tat');
                if (!$form.valid()) return;

                $button.prop('disabled', true).text('Đang xử lí...');
                $.ajax({
                    url: $form.data('action-url'),
                    data: $form.serialize(),
                    type: 'POST',
                    dataType: 'json',
                    success: function (response) {
                        if (!response.error && response.link) {
                            window.location.href = response.link;
                            return;
                        }

                        $button.prop('disabled', false).text('Tiếp tục');
                        if (response.message && typeof toastr !== 'undefined') {
                            toastr.error(response.message, response.title || 'Lỗi');
                        }
                    },
                    error: function () {
                        $button.prop('disabled', false).text('Tiếp tục');
                    }
                });
            });
        },
        checkSepayStatus: function ($checkout) {
            var self = this;
            if (self.sepay_is_success) return;

            $.ajax({
                url: $checkout.data('status-url'),
                data: {order_id: $checkout.data('order-id')},
                method: 'GET',
                dataType: 'json',
                cache: false,
                success: function (response) {
                    if (!response) return;

                    if (response.credited_to_balance) {
                        self.sepay_is_success = true;
                        clearInterval(self.sepay_status_timer);
                        $checkout.find('.js-sepay-payment-status').text('Đã cộng vào tài khoản').addClass('text-success fw-semibold');
                        $checkout.find('.js-sepay-payment-spinner').hide();

                        return;
                    }

                    if (!response.success) return;

                    self.sepay_is_success = true;
                    clearInterval(self.sepay_status_timer);
                    $checkout.find('.js-sepay-payment-status').text('Đã thanh toán').addClass('text-success fw-semibold');
                    $checkout.find('.js-sepay-payment-spinner').hide();

                }
            });
        },
        sepay: function () {
            var self = this;
            var $checkout = $('.js-sepay-checkout');

            self.sepayTopUpForm();
            if (!$checkout.length) return;

            self.checkSepayStatus($checkout);
            self.sepay_status_timer = setInterval(function () {
                self.checkSepayStatus($checkout);
            }, 5000);
        },
        init: function () {
            this.payoo();
            this.sepay();
        }
    },
    isJsonString: function (str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    },
	readImageFromInput: function(el, eTarget){
		if (el.files && el.files[0]) {
			var reader = new FileReader();

			reader.onload = function (e) {
				eTarget.attr('src', e.target.result);
			};

			reader.readAsDataURL(el.files[0]);
		}
	},
    initWithWindow: function () {
        this.lazyLoadImage();
    },
    init: function () {
        if (this.isFacebookApp()) {
            this.body.addClass('fb_inside_app');
        }
        this.layoutCommon();
        this.escapePopup();
        this.moveToTrash();
        this.media.init();
        this.payment.init();
    }
};

// khởi tạo các hàm chạy trước JQUERY
common_app.initWithWindow();

// khởi tạo các hàm sau khi jquery load
jQuery(function($) {
    // init app
    common_app.init();

    if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
        //console.log($('.js-select-tinhthanhpho').val());
        $('.js-select-tinhthanhpho').change();
        if ($.fn.select2 && $('.js-select-project').length) {
            $('.js-select-project').select2(common_app._ajax_project_search);
        }

        if ($('.js-page-dashboard').length) {
            window.location.reload();
        }
    }

    /* XỬ LÝ AJAX
    XỬ LÝ MỌI RESPONSE TỪ AJAX VỀ Ở ĐÂY
    */

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    $(document).ajaxComplete(function (event, xhr, settings) {

        // reinit facebook
        var jBody = $(document.body);
        window.show_loading = false;
        if (!xhr.responseText) return;
        // console.log(xhr.responseText);
        // console.log(common_app.isJsonString(xhr.responseText));
        if (!common_app.isJsonString(xhr.responseText)) {
            // toastr.error('Có lỗi xảy ra. Vui lòng thử lại', 'Thông báo');
            setTimeout(function () {
                // window.location.reload();
            }, 1500);
            return;
        }
        var response = JSON.parse(xhr.responseText);

        if (response.code != 200) {
            if (response.code == 500) {

                if (response.element) {
                    $(response.element).find('.js-btn-hoan-tat').text(response.button_text);
                }

                var jsonData = response.data;
                if (jsonData) {
                    for (var obj in jsonData) {
                        // toastr.error(jsonData[obj][0], response.title);

                        $('#alertTitle').text(response.title || 'Thông báo');
                        $('#alertMessage').html(jsonData[obj][0] || '');
                        var modal = new bootstrap.Modal(document.getElementById('alertModal'));
                        modal.show();

                    }
                }
                if (response.message) {
                    // toastr.error(response.message, response.title);

                    $('#alertTitle').text(response.title || 'Thông báo');
                    $('#alertMessage').html(response.message);
                    var modal = new bootstrap.Modal(document.getElementById('alertModal'));
                    modal.show();
                }
                return;
            }
            if (response.code == 403) {
                refreshCsr();
            }
        }
        if (typeof response.action == 'undefined' || response.action == '') return;
        var timeout;
        $.each(response.action.trim().split(' '), function (index, action) {
            if (action == 'close_popup') {
                $('#' + response.popup_id).modal('hide');
            }

            if (action == 'show_popup') {
                jBody.append(response.html);

                $('#' + response.popup_id).on('hidden.bs.modal', function () {
                    // Hiện tại tắt popup mình xóa luôn DOM
                    // nhưng giữ lại thằng modal
                    $(this).remove();
                    if (response.popup_id != 'add_photo_Modal') {
                        //location.reload();
                    }
                });

                $('#' + response.popup_id).modal();

                // trường hợp popup xóa cần remake lại event
                // trường hợp modal confirm trash
                if (response.popup_id == 'modal_confirm_trash') {
                    common_app.moveToTrash();
                }

                if (response.popup_id == 'add_photo_Modal') {
                    common_app.media.popupMediaModule();
                }

				// if (response.popup_id == 'modal_popup_call_add_note') {
					backend_app.processSubmitForm();
				// }
            }

            if (action == 'redirect' || action == 'redirect_delay') {
                timeout = response.delay || response.action.trim().split(' ').length > 1 ? 3000 : 500;
                setTimeout(function () {
                    window.location.href = response.link;
                }, timeout);
            }
            if (action == 'redirect_suddenly') {
                window.location.href = response.link;
            }

            if (action == 'redirect_auth') {
                window.location.href = response.link;
            }

            if (action == 'reload') {
                timeout = response.action.trim().split(' ').length > 1 ? 3000 : 500;
                setTimeout(function () {
					window.location.reload();
				}, timeout);
            }

            if (action == 'alert') {
                // toastr.options = {
                //     'closeButton': true,
                //     'showDuration': '300',
                //     'hideDuration': '3000',
                //     'timeOut': '5000'
                // };
                // toastr.info(response.message, 'Thông báo');

                $('#alertTitle').text('Thông báo');
                $('#alertMessage').html(response.message);
                var modal = new bootstrap.Modal(document.getElementById('alertModal'));
                modal.show();

            }
            if (action == 'sweetalert') {
                // Swal.fire({
				// 	title: response.title,
				// 	html: response.message,
				// 	type: response.command,
				// 	timer: 0,
				// 	showConfirmButton: true
                // });

                $('.js-alert-modal .js-alert-title').text('Thông báo');
                $('.js-alert-modal .js-alert-message').html(response.message);
                var modal = new bootstrap.Modal(document.getElementById('alertModal'));
                modal.show();
            }

            if (action == 'alert_message') {
                $('.js-alert-message').removeClass('hidden');
                $('.js-alert-message p').html(response.message);
            }

            if (action == 'alert_message_reload') {
                $('.js-alert-message').removeClass('hidden');
                $('.js-alert-message p').html(response.message);
                setTimeout(function () {
                    window.location.reload();
                }, 3000);
            }

            if (action == 'replace') {
                if (response.js_class == '.js-media-list') {
                    $(response.js_class).html(response.html);
                    common_app.media.initEventMediaModule();
                } else {
                    $(response.js_class).html(response.html);
                }

                if (typeof common_app.observer != 'undefined' && common_app.observer) {
                    common_app.observer.observe();
                }
            }
            if (action == 'replacewith') {
                $(response.js_class).replaceWith(response.html);
            }

            if (action == 'append') {
                if (response.js_class == '.js-article-wrap') {
                    /*jshint -W014 */
                    var adsense_ads = '<script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>' +
                        '<!-- bds123.vn load more -->' +
                        '<ins class="adsbygoogle"' +
                        'style="display:block; text-align:center;"' +
                        'data-ad-client="ca-pub-1713423796088709"' +
                        'data-ad-layout="in-article"' +
                        'data-ad-slot="5120163695"' +
                        'data-ad-format="fluid"></ins>' +
                        '<script>' +
                        '(adsbygoogle = window.adsbygoogle || []).push({});' +
                        '</script>';

                    var ad_append = $('<div class="ad_block size_masthead">' + adsense_ads + '</div>');
                    $(response.js_class).append(ad_append);
                }
                $(response.js_class).append(response.html);

                if (response.js_class == '.js-media-list') {
                    common_app.media.initEventMediaModule();
                    common_app.moveToTrash();
                }

                if (typeof FB != 'undefined') {
                    FB.XFBML.parse(document.getElementById('content-wrapp'));
                }

                if (typeof common_app.observer != 'undefined' && common_app.observer) {
                    common_app.observer.observe();
                }
            }

            if (action == 'remove_media_item') {
                var current_media_item = $('.js-move-to-trash').attr('data-id');
                $('#media_item_' + current_media_item).remove();
                // hide info tab
                $('.js-media-detail').addClass('hide');
            }

            if (action == 'remove_item_row') {
                setTimeout(function () {
                    $('.js-item-row-' + response.object_id).remove();
                }, 3000);
            }

            if (action == 'complete_create_post') {
                $(response.js_class).find('.form_add_new_post_step').addClass('hidden');
                $(response.js_class).find('.form_add_new_post_step.complete').removeClass('hidden');
                $(response.js_class).attr('data-current-step', 'complete');

                $(response.js_class).find('.js-post-code').html(response.post_code);
                $(response.js_class).find('.js_link_view_my_post').attr('href', response.post_url);
                $(response.js_class).find('.js_link_post').val(response.post_url);
            }

            if (action == 'scroll_to_top') {
                $('html, body').animate({
                    scrollTop: ($('body').offset().top) + 'px'
                }, 'slow');
            }

            if (action == 'get_token') {
                $('meta[name="_token"]').attr('content', response.token);
                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
                    }
                });
            }

            // if (action == 'like_action') {
            //     toastr.options = {
            //         'closeButton': true,
            //         'showDuration': '300',
            //         'hideDuration': '3000',
            //         'timeOut': '5000'
            //     };

            //     if (response.command == 'success') {
            //         toastr.success(response.message, 'Thông báo');
            //     } else if (response.command == 'info') {
            //         toastr.info(response.message, 'Thông báo');
            //     } else if (response.command == 'waring') {
            //         toastr.warning(response.message, 'Thông báo');
            //     } else if (response.command == 'error') {
            //         toastr.error(response.message, 'Thông báo');
            //     }
            // }

            if (action == 'toastr') {

                // toastr.remove();
                // toastr.options = {
                //     'closeButton': true,
                //     'showDuration': '300',
                //     'hideDuration': '2000',
                //     'timeOut': '5000'
                // };
                // if (response.command == 'success') {
                //     toastr.success(response.message, response.title);
                // } else if (response.command == 'info') {
                //     toastr.info(response.message, response.title);
                // } else if (response.command == 'waring') {
                //     toastr.warning(response.message, response.title);
                // } else if (response.command == 'error') {
                //     toastr.error(response.message, response.title);
                // } else {
                //     toastr.info(response.message, response.title);
                // }

                $('.js-alert-modal .js-alert-title').text('Thông báo');
                $('.js-alert-modal .js-alert-message').html(response.message);
                var modal = new bootstrap.Modal(document.getElementById('alertModal'));
                modal.show();

            }

            if (action == 'switch_layout') {

                $(response.element).find('.js-btn-hoan-tat').text(response.button_text);
                if (response.target == 'feedback') {
                    if (response.data_code == 200) {
                        $(response.element).find('.js-feedback-content').addClass('hidden');
                        $(response.element).find('.js-btn-hoan-tat').addClass('hidden');
                        $(response.element).find('.js-feedback-alert').removeClass('hidden');
                        return;
                    }
                }
                if (response.target == 'ask_support') {
                    if (response.data_code == 200) {
                        $(response.element).find('.js-form-submit-data').addClass('hidden');
                        $(response.element).find('.js-asksupport-alert').removeClass('hidden');
                        return;
                    }
                }
            }

            if (action == 'check_save_post') {
                var post_likeds = response.post_likeds;
                $.each(post_likeds, function (post_id, data) {
                    $('.js-btn-save[data-post-id="' + post_id + '"]').attr('title', data.text);
                    $('.js-btn-save[data-post-id="' + post_id + '"]').find('span').html(data.text);
                    if (data.liked == 1) {
                        $('.js-btn-save[data-post-id="' + post_id + '"]').addClass('saved');
                    } else {
                        $('.js-btn-save[data-post-id="' + post_id + '"]').removeClass('saved');
                    }
                });

				$('.js-save-post-total').html(response.total_post_like);
				if(response.total_post_like == 0){
					$('.js-save-post-total').addClass('hidden');
				}else{
					$('.js-save-post-total').removeClass('hidden');
				}
            }
            if (action == 'save_multiposts') {
                $('.js-save-post-total').html(response.total_post_like);
				if(response.total_post_like == 0){
					$('.js-save-post-total').addClass('hidden');
				}else{
					$('.js-save-post-total').removeClass('hidden');
				}

				localStorage.removeItem('post_favorist');
            }

            if (action == 'replace_array_html') {
                $.each(response.responses, function (key, html) {
                    $(key).html(html);
					$(key).removeClass('hidden');
                });

				if (typeof common_app.observer != 'undefined' && common_app.observer) {
					common_app.observer.observe();
				}

				// REPLACE HEADER
				if(response.authenticated && response.total_post_like ){
					$('.js-save-post-total').html(response.total_post_like);
					if(response.total_post_like == 0){
						$('.js-save-post-total').addClass('hidden');
					}else{
						$('.js-save-post-total').removeClass('hidden');
					}
				}else{
					var str_post_favorist = localStorage.getItem('post_favorist');
					if(str_post_favorist && typeof str_post_favorist !== 'undefined'){
						common_app.post_favorists = JSON.parse(str_post_favorist);
					}
					if(common_app.post_favorists.length){
						$('.js-save-post-total').html(common_app.post_favorists.length);
						if(common_app.post_favorists.length == 0){
							$('.js-save-post-total').addClass('hidden');
						}else{
							$('.js-save-post-total').removeClass('hidden');
						}

						$('.js-btn-save').each(function (index, el) {
							for(var i = 0; i<common_app.post_favorists.length; i++){
								if($(el).attr('data-post-id') == common_app.post_favorists[i].post_id){
									$(el).addClass('saved');
									$(el).find('span').html('Tin đã lưu');
								}
							}
						});
					}
				}
            }

            if (action == 'not_logged') {
				localStorage.removeItem('authenticated', response.authenticated);
				localStorage.removeItem('access_token', response.access_token);
				localStorage.removeItem('verified', response.verified);
				localStorage.removeItem('bds123.user_data', JSON.stringify(response.user));
			}

            if (action == 'logged_in') {
                localStorage.setItem('authenticated', response.authenticated);
                localStorage.setItem('access_token', response.access_token);
                localStorage.setItem('verified', response.verified);
                localStorage.setItem('bds123.user_data', JSON.stringify(response.user));

				var fav_data_post_ids = [];
				var str_post_favorist = localStorage.getItem('post_favorist');
				if(str_post_favorist && typeof str_post_favorist !== 'undefined'){
					common_app.post_favorists = JSON.parse(str_post_favorist);
				}
				if(common_app.post_favorists && common_app.post_favorists.length){
					for(var i = 0; i<common_app.post_favorists.length; i++){
						fav_data_post_ids.push(common_app.post_favorists[i].post_id);
					}
				}
				if(fav_data_post_ids.length){
					var paged = common_app.search.getParameterByName('page') || 1;
					$.ajax({
						url: base_url + '/api/posts/save',
						data: {
							post_ids: fav_data_post_ids
						},
						type: 'POST',
						dataType: 'json'
					});
				}

				if($('.js-btn-dang-tin').length){
					$('.js-btn-dang-tin').find('span').html(response.btn_dang_tin_text)
				}
            }

            if (action == 'rating') {
                $('.js-rating-social-wrap').find('.js-rating-point').html(response.rating_average);
                $('.js-rating-social-wrap').find('.js-rating-count').html(response.rating_sum);
                $('.js-rating-social-wrap').find('.js-rating-label-result').html(response.rating_text);
            }

            if (action == 'offline_store') {
                $('.js-payment-number').html(response.billingCode);
                $('.js-payment-at-store').find('.js-payment-step').addClass('hidden');
                $('.js-payment-step.step-2').removeClass('hidden');

                $('.js-date-expired').html(response.validate_time);
            }

            if (action == 'qrcode') {
                // toastr.remove();
                if (!response.QRCodeLink) {
                    // toastr.info('Thông báo', 'Có lỗi xảy ra. Vui lòng thử lại!');
					// Swal.fire(
					// 	'Thông báo!',
					// 	'Có lỗi xảy ra. Vui lòng thử lại!',
					// 	'info'
                    // );

                    $('#alertTitle').text('Thông báo');
                    $('#alertMessage').html('Có lỗi xảy ra. Vui lòng thử lại!');
                    var modal = new bootstrap.Modal(document.getElementById('alertModal'));
                    modal.show();

                    return;
                }
                common_app.payment.showPayooQRCode(response);
            }

            if (action == 'get_verify_code') {
                if ($('.js-input-verify-wrap').length) {
                    $('.js-verify-step').addClass('hidden');
                    $('.js-input-verify-wrap').removeClass('hidden');
                    $('.js-input-verify-wrap').find('.js-alert-message').html(data.message);
                }
                $('.js-input-phone').attr('readonly', 'readonly').addClass('disabled');
                $('.js-btn-cap-nhat').removeAttr('disabled').removeClass('disabled');
            }

            if (action == 'data_medias') {
                var $html = '';
                $.each(response.data, function (index, $image) {
                    $image_url = $image.full_image_900_url;
                    $file_url = $image.image_url;
                    if ($image.file_type != 'image') {
                        $image_url = base_url + '/images/exts/icon-' + $image.extension + '.png';
                        $file_url = $image.file_url;
                        if ($image.file_type == 'video') {
                            $file_url = $image.video_url;
                        }
                    }
                    $html += '<div id="media_item_' + $image.id + '" class="media_item js-media-item ' + $image.file_type + '" data-file-type="' + $image.file_type + '" data-extension="' + $image.extension + '" data-id="' + $image.id + '" data-path-url="' + $image.image_path + '" data-url="' + $file_url + '" data-title="' + $image.filename + '" data-description="' + $image.description + '" data-alt-title="' + $image.alt_title + '" data-file-name="' + $image.filename + '" data-width="' + $image.width + '" data-height="' + $image.height + '" data-size="' + $image.size + '" data-created-at="' + $image.created_at + '">' +
                        '<div class="media_item_preview">' +
                        '<div class="media_item_thumbail">';

					$html += '<img src="' + $image_url + '">';

                    if ($image.file_type == 'video') {
                        $html += '<video width="100%" height="100%">' +
                            '<source src="' + $file_url + '" type="video/mp4">' +
                            'Your browser does not support the video tag.' +
                            '</video>';
                    }

                    if ($image.file_type == 'file' || $image.file_type == 'other') {
                        $html += '<span>' + $image.original_filename + '</span>';
                    }

                    $html += '</div>' +
                        '</div>' +
                        '<button type="button" class="check"><span class="media-modal-icon"></span></button>' +
                        '</div>';
                });

				if(common_app.html_action == 'append'){
					$('.js-media-list').append($html);
				}else{
					$('.js-media-list').html($html);
				}
                common_app.media.initEventMediaModule();
                common_app.moveToTrash();
            }

            if (action == 'verify_code') {
                $('.js-change-phone-step').addClass('hidden');
                $('.js-change-phone-step-2').removeClass('hidden');
            }

            if (action == 'mark-notification-read-all') {
				$('.js-notification-item').each(function(index, el){
					$(el).find('.js-read-notification').remove();
					$(el).addClass('read');
				});
            }

			if (action == 'user_last_activity') {
				if(response.is_online){
					$('.js-author-online-status').addClass('online');
				}else{
					$('.js-author-online-status').removeClass('online').addClass('offline');
				}
				$('.js-author-online-status').find('span').html(response.last_activity);
				$('.js-author-online-status').removeClass('hidden');
			}

        });
    });

    var is_requesting = false;

    /* ========================== *\
    XỬ LÝ AJAX
    CHẮC CHẮN RẰNG TOKEN được gửi
    kèm data khi POST/GET.
    \* ========================== */

    window.sendToken = function (phone_number, data_action_url, action) {
        action = action || 'verify';

        if (!phone_number || !validatePhone(phone_number)) {
            alert('Vui lòng nhập đúng Format số điện thoại: Vd 0981234567 hoặc 012341234567');
            return;
        }

        phone_number = reformatPhone(phone_number);

        $.ajax({
            url: data_action_url,
            data: {
                'phone_or_email': phone_number,
                'action': action
            },
            type: 'POST',
            dataType: 'json',
        });
    };

    window.refreshCsr = function () {
        $.ajax({
            type: 'GET',
            url: base_api_url + '/utility/token',
            success: function (response) {
                if (jBody.hasClass('js-page-dashboard')) {
                    // toastr.info('Vui lòng thử lại', 'Thông báo');

                    $('.js-alert-modal .js-alert-title').text('Thông báo');
                    $('.js-alert-modal .js-alert-message').html('Vui lòng thử lại');
                    var modal = new bootstrap.Modal(document.getElementById('alertModal'));
                    modal.show();

                }

                $('meta[name="_token"]').attr('content', response.token);

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
                    }
                });
            }
        });
    };

    if(typeof window.recaptchaCallback !== undefined){
		window.recaptchaCallback = function(response){
			if($('.js-form-submit-data').length){
				$('.js-form-submit-data').find('button[type="submit"]').prop('disabled', false);
				$('.js-form-submit-data').find('button[type="submit"]').removeClass('disabled');
			}else{
				$('.g-recaptcha').closest('form').find('button[type="submit"], .js-btn-get-verify-code').prop('disabled', false);
				$('.g-recaptcha').closest('form').find('button[type="submit"], .js-btn-get-verify-code').removeClass('disabled');
			}
		};
	}

    document.addEventListener('DOMContentLoaded', function () {
        var modal = document.getElementById('ModalAdvance');
        if (modal) {
            modal.addEventListener('shown.bs.modal', function () {
                var targetElement = document.getElementById('Block_Price');
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        }
    });

    if ($('.js-tooltip').length) {
        $('.js-tooltip').each(function () {
            new bootstrap.Tooltip(this);
        });
    }

    if ($('.js-popover').length) {
        $('.js-popover').each(function () {
            new bootstrap.Popover(this, {
                trigger: 'focus',
                placement: 'top'
            });
        });
    }

    document.querySelectorAll('.js-password-toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
            const inputGroup = this.closest('.input-group');
            const passwordInput = inputGroup.querySelector('.js-password-input');
            const eyeIcon = this.querySelector('.js-password-eye-icon');

            if (!passwordInput || !eyeIcon) return;

            const isHidden = passwordInput.type === 'password';

            passwordInput.type = isHidden ? 'text' : 'password';

            eyeIcon.setAttribute(
                'href',
                isHidden ? '#icon-eye-off' : '#icon-eye'
            );

            this.setAttribute('aria-pressed', String(isHidden));
            this.setAttribute(
                'aria-label',
                isHidden ? 'Ẩn mật khẩu' : 'Hiển thị mật khẩu'
            );
        });
    });

    // nhap ma xac thuc
    (function () {
        function getOtpInputs(form) {
            return Array.from(
                form.querySelectorAll('.js-verify-digit')
            );
        }

        function updateVerifyCode(form) {
            const otpInputs = getOtpInputs(form);
            const verifyCodeInput = form.querySelector('.js-input-verify-code');

            if (!verifyCodeInput) return;

            verifyCodeInput.value = otpInputs
                .map(function (input) {
                    return input.value;
                })
                .join('');

            // Báo cho các đoạn JavaScript khác biết giá trị đã thay đổi
            verifyCodeInput.dispatchEvent(
                new Event('input', { bubbles: true })
            );
        }

        function fillOtp(code, form) {
            const otpInputs = getOtpInputs(form);

            const digits = String(code)
                .replace(/\D/g, '')
                .slice(0, otpInputs.length);

            otpInputs.forEach(function (input, index) {
                input.value = digits.charAt(index);
            });

            updateVerifyCode(form);

            const firstEmptyInput = otpInputs.find(function (input) {
                return input.value === '';
            });

            if (firstEmptyInput) {
                firstEmptyInput.focus();
            } else if (otpInputs.length) {
                otpInputs[otpInputs.length - 1].focus();
            }
        }

        /*
         * Dùng event delegation để vẫn hoạt động khi form
         * được hiển thị hoặc render lại sau DOMContentLoaded.
         */
        document.addEventListener('paste', function (event) {
            if (!event.target.matches('.js-verify-digit')) {
                return;
            }

            event.preventDefault();

            const pastedText = event.clipboardData
                ? event.clipboardData.getData('text')
                : '';

            const form = event.target.closest('form');

            if (!form) {
                return;
            }

            fillOtp(pastedText, form);
        });

        document.addEventListener('input', function (event) {
            if (!event.target.matches('.js-verify-digit')) {
                return;
            }

            const input = event.target;
            const form = input.closest('form');

            if (!form) {
                return;
            }

            const otpInputs = getOtpInputs(form);
            const index = otpInputs.indexOf(input);
            const digits = input.value.replace(/\D/g, '');

            // Hỗ trợ trình duyệt tự động điền toàn bộ OTP
            if (digits.length > 1) {
                fillOtp(digits, form);
                return;
            }

            input.value = digits.slice(0, 1);
            updateVerifyCode(form);

            if (
                input.value &&
                index < otpInputs.length - 1
            ) {
                otpInputs[index + 1].focus();
            }
        });

        document.addEventListener('keydown', function (event) {
            if (!event.target.matches('.js-verify-digit')) {
                return;
            }

            const input = event.target;
            const form = input.closest('form');

            if (!form) {
                return;
            }

            const otpInputs = getOtpInputs(form);
            const index = otpInputs.indexOf(input);

            if (
                event.key === 'Backspace' &&
                input.value === '' &&
                index > 0
            ) {
                event.preventDefault();

                otpInputs[index - 1].value = '';
                otpInputs[index - 1].focus();

                updateVerifyCode(form);
            }
        });
    })();

});
